module.exports = __webpack_public_path__ + "static/media/2020-arsredovisning-brf-lyfta.e878c093.pdf";